import Vue from "vue";
import Router from "vue-router";

import TheDashboard from "@/pages/TheDashboard";
import TheConstructions from "@/pages/TheConstructions";
import TheConstructionDetails from "@/pages/TheConstructionDetails";
import TheConstructionForm from "@/pages/TheConstructionForm";
import TheConstractionDivision from "@/pages/TheConstractionDivision";
// import TheCashRaport from "@/pages/TheCashRaport";
import TheSubcontractors from "@/pages/TheSubcontractors";
import ThePriceList from "@/pages/ThePriceList";
import TheBills from "@/pages/TheBills";

import TheClients from "@/pages/TheClients";
import TheAccount from "@/pages/TheAccount";
import TheEmployees from "@/pages/TheEmployees";
import TheWorkSchedule from "@/pages/TheWorkSchedule.vue";
import TheHolidays from "@/pages/TheHolidays";
import TheCompanies from "@/pages/TheCompanies";
import TheDocuments from "@/pages/TheDocuments";
import TheWarehouse from "@/pages/TheWarehouse";
import TheMaterials from "@/components/warehouse/TheMaterials";
import TheIssuance from "@/components/warehouse/TheIssuance";
import TheDeliveries from "@/components/warehouse/TheDeliveries";

import TheLogin from "@/pages/TheLogin";
import TheError from "@/pages/TheError";

import TheTests from "@/pages/TheTests";
import TheOpos from "@/pages/TheOpos";

import {
  TokenService
} from "./services/storage.service";
import store from "@/store";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/dashboard",
      name: "Pulpit",
      component: TheDashboard,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-tachometer-alt",
        permission: "dashboardView"
      }
    },
    {
      path: "/construction",
      name: "Budowy",
      component: TheConstructions,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-home",
        permission: "constructionsView"
      }
    },
    {
      path: "/construction/add",
      name: "Dodaj budowe",
      component: TheConstructionForm,
      meta: {
        isPublic: false,
        parent: {
          name: "Budowy",
          icon: "fas fa-home",
          path: "/construction"
        },
        permission: "constructionsModify"
      }
    },
    {
      path: "/construction/:id",
      name: "Budowa",
      component: TheConstructionDetails,
      meta: {
        isPublic: false,
        parent: {
          name: "Budowy",
          icon: "fas fa-home",
          path: "/construction"
        },
        permission: "constructionsView"
      }
    },
    {
      path: "/construction/:id/add",
      name: "Dodaj podbudowe",
      component: TheConstructionForm,
      meta: {
        isPublic: false,
        parent: {
          name: "Budowy",
          icon: "fas fa-home",
          path: "/construction"
        },
        permission: "constructionsModify"
      }
    },
    {
      path: "/constraction_division",
      name: "Rozdział budów",
      component: TheConstractionDivision,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-city",
        permission: "constractionSectionView"
      }
    },
    //--- MAGAZYN
    {
      path: "/warehouse",
      name: "Magazyn",
      component: TheWarehouse,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-warehouse",
        permission: "materialsView"
      },
      children: [{
        path: "/warehouse/materials",
        name: "Materiały",
        component: TheMaterials,
        meta: {
          isPublic: false,
          icon: "fas fa-boxes",
          permission: "materialsView",
          parent: {
            name: "Magazyn",
            path: undefined
          }
        }
      },
      {
        path: "/warehouse/issuance",
        name: "Wydania",
        component: TheIssuance,
        meta: {
          isPublic: false,
          icon: "fas fa-file-signature",
          permission: "materialsView",
          parent: {
            name: "Magazyn",
            path: undefined
          }
        }
      },
      {
        path: "/warehouse/deliveries",
        name: "Dostawy",
        component: TheDeliveries,
        meta: {
          isPublic: false,
          icon: "fas fa-truck",
          permission: "materialsView",
          parent: {
            name: "Magazyn",
            path: undefined
          }
        }
      },
      ]
    },
    // {
    //   path: "/cash_raport",
    //   name: "Raport kasowy",
    //   component: TheCashRaport,
    //   meta: {
    //     isPublic: false,
    //     category: "main",
    //     icon: "fas fa-cash-register",
    //     permission: "cashraportView"
    //   }
    // },
    {
      path: "/subcontractors",
      name: "Podwykonawcy",
      component: TheSubcontractors,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-hard-hat",
        permission: "subcontractorsView"
      }
    },
    {
      path: "/pricelist",
      name: "Cennik",
      component: ThePriceList,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-clipboard-list",
        permission: "productsView"
      }
    },
    {
      path: "/bills",
      name: "Rachunki",
      component: TheBills,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-money-check-alt",
        permission: "billsView"
      }
    },
    {
      path: "/customers",
      name: "Klienci",
      component: TheClients,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-user-tie",
        permission: "customersView"
      }
    },
    {
      path: "/schedule",
      name: "Ewidencja czasu",
      component: TheWorkSchedule,
      meta: {
        isPublic: false,
        category: "main",
        icon: "fas fa-briefcase",
        permission: "schedulesView"
      }
    },
    {
      path: "/account",
      name: "Moje konto",
      component: TheAccount,
      meta: {
        isPublic: false,
        // onlyWhenLoggedOut: true,
        category: "USTAWIENIA",
        icon: "fas fa-id-card",
      }
    },
    {
      path: "/companies",
      name: "Firmy",
      component: TheCompanies,
      meta: {
        isPublic: false,
        // onlyWhenLoggedOut: true,
        category: "USTAWIENIA",
        icon: "far fa-building",
        permission: "companiesView"
      }
    },
    //Wzory dokumentów
    {
      path: "/documents",
      name: "Wzory dokumentów",
      component: TheDocuments,
      meta: {
        isPublic: false,
        icon: "fas fa-book",
        category: "USTAWIENIA",
        permission: "documentView",
      }
    },
    {
      path: "/users",
      name: "Pracownicy",
      component: TheEmployees,
      meta: {
        isPublic: false,
        // onlyWhenLoggedOut: true,
        category: "USTAWIENIA",
        icon: "fas fa-users",
        permission: "employeesView"
      }
    },
    {
      path: "/holidays",
      name: "Urlopy",
      component: TheHolidays,
      meta: {
        isPublic: false,
        // onlyWhenLoggedOut: true,
        category: "USTAWIENIA",
        icon: "fas fa-suitcase-rolling",
        permission: "holidaysView"
      }
    },
    {
      path: "/tests",
      name: "Testy",
      component: TheTests,
      meta: {
        isPublic: false,
        // onlyWhenLoggedOut: true,
        category: "USTAWIENIA",
        icon: "fas fa-bug",
        permission: "testsView"
      }
    },
    {
      path: "/opos",
      name: "OPOS",
      component: TheOpos,
      meta: {
        isPublic: false,
        // onlyWhenLoggedOut: true,
        category: "USTAWIENIA",
        icon: "fas fa-table",
        permission: "oposView"
      }
    },
    {
      path: "/",
      alias: "/login",
      name: "Zaloguj się",
      component: TheLogin,
      meta: {
        isPublic: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      name: "Error404",
      path: "*",
      component: TheError,
      meta: {
        isPublic: true,
        onlyWhenLoggedOut: false
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let isPublic = to.matched.some(record => record.meta.isPublic);
  let onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
  let loggedIn = !!TokenService.getToken();
  if (isPublic === false && loggedIn === false) {
    return next({
      path: "/login",
      query: {
        redirect: to.fullPath
      }
    });
  }
  if (loggedIn && onlyWhenLoggedOut) {
    return next("/dashboard");
  }
  //Check permission only when page is not public and user is loaded and to router have set meta permission
  if (!isPublic && to.meta.permission && store.getters["user/userLoaded"] && store.getters["user/hasAccess"](to.meta.permission) === false) {
    next("/error");
    return;
  }
  document.title = ((to.name) ? (to.name + " - ") : "") + store.getters["app/name"];
  next();
});
export default router;
